'use client'

import { Input } from 'antd'
import { SBDynamicFormInput } from './types'

const SBDynamicFormInputLastName: SBDynamicFormInput = ({ ...rest }) => {
  return <Input {...rest} autoComplete="family-name" />
}

export { SBDynamicFormInputLastName }
